module.exports = __webpack_public_path__ + "img/Flag_of_Guyana.3d50da7f.svg";